/* eslint-disable */
import { getLocale, trackMessageCall, experimentalMiddlewareLocaleSplitting, isServer, experimentalStaticLocale } from '../runtime.js';
/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

const en_pctsol_faq_a1 = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Weight/volume percent is the grams of solute dissolved in 100 mL of total solution. A 1% w/v solution contains 1 g of solute per 100 mL.`)
};

const es_pctsol_faq_a1 = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`El porcentaje peso/volumen es los gramos de soluto disueltos en 100 mL de solución total. Una solución al 1% p/v contiene 1 g de soluto por cada 100 mL.`)
};

const de_pctsol_faq_a1 = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Gewicht/Volumen-Prozent ist die Anzahl der Gramm gelösten Stoffes in 100 mL Gesamtlösung. Eine 1%ige w/v-Lösung enthält 1 g gelösten Stoff pro 100 mL.`)
};

const nl_pctsol_faq_a1 = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Gewicht/volumepercentage is het aantal gram opgeloste stof opgelost in 100 mL totale oplossing. Een 1% g/v oplossing bevat 1 g opgeloste stof per 100 mL.`)
};

const fr_pctsol_faq_a1 = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Le pourcentage poids/volume est le nombre de grammes de soluté dissous dans 100 mL de solution totale. Une solution à 1 % p/v contient 1 g de soluté par 100 mL.`)
};

const it_pctsol_faq_a1 = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`La percentuale peso/volume è i grammi di soluto disciolti in 100 mL di soluzione totale. Una soluzione all'1% p/v contiene 1 g di soluto ogni 100 mL.`)
};

const pt_br2_pctsol_faq_a1 = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Percentual peso/volume é a quantidade de gramas de soluto dissolvidas em 100 mL de solução total. Uma solução 1% p/v contém 1 g de soluto por 100 mL.`)
};

const pt_pctsol_faq_a1 = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`A percentagem massa/volume é o número de gramas de soluto dissolvidas em 100 mL de solução total. Uma solução a 1% m/v contém 1 g de soluto por 100 mL.`)
};

const ja_pctsol_faq_a1 = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`重量/体積パーセントは、溶液全体100 mLに溶けている溶質のグラム数です。1% w/v溶液は100 mLあたり1 gの溶質を含みます。`)
};

const zh_pctsol_faq_a1 = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`重量/体积百分比是每 100 mL 总溶液中溶解的溶质克数。1% w/v 溶液每 100 mL 含 1 g 溶质。`)
};

/**
* This function has been compiled by [Paraglide JS](https://inlang.com/m/gerre34r).
*
* - Changing this function will be over-written by the next build.
*
* - If you want to change the translations, you can either edit the source files e.g. `en.json`, or
* use another inlang app like [Fink](https://inlang.com/m/tdozzpar) or the [VSCode extension Sherlock](https://inlang.com/m/r7kp499g).
* 
* @param {{}} inputs
* @param {{ locale?: "en" | "es" | "de" | "nl" | "fr" | "it" | "pt-BR" | "pt" | "ja" | "zh" }} options
* @returns {LocalizedString}
*/
/* @__NO_SIDE_EFFECTS__ */
export const pctsol_faq_a1 = (inputs = {}, options = {}) => {
	if (experimentalMiddlewareLocaleSplitting && isServer === false) {
		return /** @type {any} */ (globalThis).__paraglide_ssr.pctsol_faq_a1(inputs) 
	}
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	trackMessageCall("pctsol_faq_a1", locale)
	if (locale === "en") return en_pctsol_faq_a1(inputs)
	if (locale === "es") return es_pctsol_faq_a1(inputs)
	if (locale === "de") return de_pctsol_faq_a1(inputs)
	if (locale === "nl") return nl_pctsol_faq_a1(inputs)
	if (locale === "fr") return fr_pctsol_faq_a1(inputs)
	if (locale === "it") return it_pctsol_faq_a1(inputs)
	if (locale === "pt-BR") return pt_br2_pctsol_faq_a1(inputs)
	if (locale === "pt") return pt_pctsol_faq_a1(inputs)
	if (locale === "ja") return ja_pctsol_faq_a1(inputs)
	return zh_pctsol_faq_a1(inputs)
};